import React from "react";
import { EcpEnrollmentTable } from "../entities/ecp/ecp-enrollment-entity";

export function EcpEnrollmentsPage(props) {
  return <EcpEnrollmentTable {...props} />;
}
